var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 118,
    viewBox: "0 0 55 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8658 26.5133C53.7867 11.9546 41.9347 0.486328 27.473 0.486328C13.0112 0.486328 1.1592 11.9546 0.0801002 26.5133H0V87.2431H0.0801002C0.027087 87.9589 0 88.6822 0 89.412C0 104.984 12.3001 117.608 27.473 117.608C42.6458 117.608 54.9459 104.984 54.9459 89.412C54.9459 88.6822 54.9188 87.9589 54.8658 87.2431H54.9459V26.5133H54.8658Z",
    fill: "#F39100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa1);
export default __webpack_public_path__ + "static/media/IA_1.05ca1ad97c2e1f22c0b55343686f2a1b.svg";
export { ForwardRef as ReactComponent };